export default "__VITE_ASSET__CWhZkS1F__"